<template>
  <div class="home-box show-flex-box-c">
    <div class="show-flex-box-c">
      <homeBanner></homeBanner>
      <userLogIn></userLogIn>
      <trialAccount></trialAccount>
      <chargeCourse></chargeCourse>
      <!-- <chooseMars></chooseMars> -->
      <teacherTeam></teacherTeam>
      <courseSupport></courseSupport>
      <marsBox></marsBox>
      <!-- <teachingSupport></teachingSupport> -->
      <!-- <educationSystem></educationSystem> -->
      <!-- <coperationProcess></coperationProcess> -->
      <!-- <cooperationCase></cooperationCase> -->
      <coperationArea></coperationArea>
      <!-- <mediaReport></mediaReport> -->
      <advertisement></advertisement>
    </div>
  </div>
</template>

<script>
import homeBanner from '@/components/home/home_banner_cpn'                 //首页banner图
import userLogIn from '@/components/login/user_login'                      //登录
import trialAccount from '@/components/home/trial_account_cpn'             //试用
import chargeCourse from '@/components/home/charge_course_cpn'             //兑换课程
import chooseMars from '@/components/home/choose_mars_box_cpn'             //选择德阳经开科创
import teacherTeam from '@/components/home/teacher_team_cpn'               //教研团队
import courseSupport from '@/components/home/course_support_cpn'           //课程支持
import marsBox from '@/components/home/mars_box_cpn'                       //硬件支持
import teachingSupport from '@/components/home/teaching_support_cpn'       //教学支持
import educationSystem from '@/components/home/education_system_cpn'       //培训体系
import coperationProcess from '@/components/home/coperation_process_cpn'   //合作流程
import cooperationCase from '@/components/home/cooperation_case_cpn'       //合作案例
import coperationArea from '@/components/home/coperation_area_cpn'       //合作地区
import mediaReport from '@/components/home/media_report_cpn'          //媒体报道
import advertisement from '@/components/home/advertisement_cpn'          //广告

export default {
  name: 'home',
  data () {
    return {
      scrollTop: 0
    }
  },
  components: {
    homeBanner,    // 首页banner图
    userLogIn,
    chooseMars,    // 选择德阳经开科创
    trialAccount,  //试用
    chargeCourse,  //兑换课程
    teacherTeam,   // 教研团队
    courseSupport,  // 课程支持
    marsBox,        //硬件支持
    teachingSupport,  // 教学支持
    educationSystem,   // 培训体系
    coperationProcess,   // 合作流程
    cooperationCase,    // 合作案例
    coperationArea,      //合作地区
    mediaReport,         //媒体报道
    advertisement       //广告
  },
}
</script>

<style lang="less" scoped>
  .home-box{
    position: relative;
    width: 100%;
    &>div{
      width: 100%;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue